import React, { createContext, useState, useEffect } from 'react';

// Create context
export const FamilyContext = createContext();

export const FamilyProvider = ({ children }) => {
    const [familyMembers, setFamilyMembers] = useState([]);
    const [events, setEvents] = useState([]);
    const [businesses, setBusinesses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Fetch family data
    useEffect(() => {
        const fetchFamilyData = async () => {
            try {
                setLoading(true);

                // In a real application, you would fetch this data from an API
                // For this example, we'll use mock data

                // Mock family members data
                const mockFamilyMembers = [
                    {
                        id: 1,
                        name: 'Robert Dumani',
                        age: 68,
                        branch: 'Main',
                        location: 'New York, NY',
                        occupation: 'Retired Construction Executive',
                        bio: 'Founder of Dumani & Sons Construction, now enjoying retirement and mentoring young entrepreneurs.',
                        image: 'https://source.unsplash.com/random/300x300/?man',
                        email: 'robert@familyemail.com',
                        phone: '(555) 123-4567'
                    },
                    {
                        id: 2,
                        name: 'Sarah Dumani',
                        age: 65,
                        branch: 'Main',
                        location: 'New York, NY',
                        occupation: 'Community Organizer',
                        bio: 'Dedicated to community service and organizing the annual family reunion for over 30 years.',
                        image: 'https://source.unsplash.com/random/300x300/?woman',
                        email: 'sarah@familyemail.com',
                        phone: '(555) 123-4568'
                    },
                    // Add more family members as needed
                ];

                // Mock events data
                const mockEvents = {
                    upcoming: [
                        {
                            id: 1,
                            title: 'Annual Clan Reunion 2025',
                            date: 'August 15, 2025',
                            description: 'Join us for our annual clan reunion. Food, games, and memories await!',
                            location: 'Bulawayo',
                            image: 'https://dx8i2mtk03zrn.cloudfront.net/content/umlalazi.png'
                        },
                        {
                            id: 2,
                            title: 'Holiday Celebration',
                            date: 'December 25, 2025',
                            description: 'Our traditional holiday celebration with gift exchange and special dinner.',
                            location: 'Harare',
                            image: 'https://dx8i2mtk03zrn.cloudfront.net/content/umlalazi.png'
                        },
                        {
                            id: 3,
                            title: 'Clan Business Summit',
                            date: 'October 10, 2025',
                            description: 'A gathering of all clan businesses to share insights and plan for the future.',
                            location: 'Gweru',
                            image: 'https://dx8i2mtk03zrn.cloudfront.net/content/umlalazi.png'
                        }
                    ],
                    past: [
                        {
                            id: 4,
                            title: 'Johannesburg Umbrella Committee Meeting',
                            date: 'May 5, 2025',
                            description: 'Committee discusses elections, upcoming events, and participation standards.',
                            location: 'Langlaagte Station',
                            image: 'https://dx8i2mtk03zrn.cloudfront.net/content/1000345944.jpg'
                        },
                        {
                            id: 5,
                            title: 'Harare Youth Meeting',
                            date: 'May 3, 2025',
                            description: 'Harare youth receive support towards agric project',
                            location: 'Seke Village',
                            image: 'https://dx8i2mtk03zrn.cloudfront.net/content/1000348885.jpg'
                        },
                        // Add more past events as needed
                    ]
                };

                // Mock businesses data
                const mockBusinesses = [
                    {
                        id: 1,
                        name: 'Dumani & Sons Construction',
                        owner: 'Robert Dumani',
                        founded: '1978',
                        description: 'A premier construction company specializing in residential and commercial buildings, known for quality craftsmanship and timely delivery.',
                        image: 'https://source.unsplash.com/random/400x300/?construction',
                        website: 'https://Dumaniconstruction.example.com',
                        contact: 'info@Dumaniconstruction.example.com'
                    },
                    {
                        id: 2,
                        name: 'Green Valley Farms',
                        owner: 'Michael & Sarah Dumani',
                        founded: '1992',
                        description: 'An organic farm producing sustainable fruits, vegetables, and dairy products for the local community and regional markets.',
                        image: 'https://source.unsplash.com/random/400x300/?farm',
                        website: 'https://greenvalleyfarms.example.com',
                        contact: 'info@greenvalleyfarms.example.com'
                    },
                    // Add more businesses as needed
                ];

                // Set state with mock data
                setFamilyMembers(mockFamilyMembers);
                setEvents(mockEvents);
                setBusinesses(mockBusinesses);
                setLoading(false);
            } catch (error) {
                setError('Failed to fetch family data');
                setLoading(false);
                console.error('Error fetching family data:', error);
            }
        };

        fetchFamilyData();
    }, []);

    // Context value
    const value = {
        familyMembers,
        events,
        businesses,
        loading,
        error
    };

    return (
        <FamilyContext.Provider value={value}>
            {children}
        </FamilyContext.Provider>
    );
};